import React from 'react';
import reportWebVitals from './reportWebVitals';
import App from './App';

import { createRoot } from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';
import oidcConfig from './utils/oidcConfig';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <AuthProvider {...oidcConfig}>
    <App tab="home" />
  </AuthProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
